webpackJsonp([4910047194780788000],{

/***/ "./src/images/redux.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/redux.f73de4f0.png";

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/vysakh/docs/reactjs-sataiva/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-plugin-lodash/lib/index.js\",\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/redux-intro/library.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MainLayout = __webpack_require__("./src/components/MainLayout.jsx");
	
	var _MainLayout2 = _interopRequireDefault(_MainLayout);
	
	var _CtaButton = __webpack_require__("./src/components/CtaButton.jsx");
	
	var _CtaButton2 = _interopRequireDefault(_CtaButton);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Block = __webpack_require__("./src/components/Block.jsx");
	
	var _Block2 = _interopRequireDefault(_Block);
	
	var _redux = __webpack_require__("./src/images/redux.png");
	
	var _redux2 = _interopRequireDefault(_redux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initReactJsx = '\n<html>\n<head>\n<script src="https://cdnjs.cloudflare.com/ajax/libs/redux/3.7.2/redux.js"></script>\n</head>\n\n<body>\n  <div id="app">\n  </div>\n</body>\n</html>\n';
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        _MainLayout2.default,
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            { title: "Redux introduction tutorial - 2018" },
	            _react2.default.createElement('meta', { name: 'description', content: 'If you know javascript, this introductory  tutorial will be easy for you. You will learn reduxjs as simple library without node.' })
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'p',
	                null,
	                'Reduxjs is a very simple js library. So, create an index.html in your Desktop with this content'
	            ),
	            _react2.default.createElement(_Block2.default, { title: '', lang: 'html', value: initReactJsx }),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Open the file in your browser. In your js console, as you type Re, it\'d autocomplete as Redux. Meaning we have access to the redux class, let\'s use it.'
	            ),
	            _react2.default.createElement('img', { src: _redux2.default, alt: 'simple redux' }),
	            _react2.default.createElement(
	                _CtaButton2.default,
	                { to: '/redux-intro/example' },
	                'Cool, next'
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-redux-intro-library-jsx-543b62b8ef1c40e218be.js